import React from "react";
import { TextAreaProps } from "./TextArea.types";
import './TextArea.scss'
export const TextArea: React.FC<TextAreaProps> = ({
  shape,
  error,
  success,
  defaultValue = '',
  disabled = false,
  id = null,
  name = null,
  autoComplete,
  onAnimationStart = () => false,
  onBlur = () => false,
  onChange = () => false,
  onFocus = () => false,
  onKeyUp = () => false,
  onKeyDown = () => false,
  placeholder = null,
  readOnly = false,
  value,
  label,
  textAreaClassName,
  ref,
  height,
  width,
  ...props
}) => {
  let textareaClass = `alteon-textarea-container alteon-textarea-${shape}`;
  if (success && !error) {
    textareaClass = `alteon-textarea-container alteon-textarea-success alteon-textarea-${shape}`;
  }
  if (error && !success) {
    textareaClass = `alteon-textarea-container alteon-textarea-error alteon-textarea-${shape}`;
  }
  if (disabled) {
    textareaClass = `alteon-textarea-container alteon-textarea-disabled alteon-textarea-${shape}`;
  }
  return (
    <div id="alteon-text-area-component-container" className={textareaClass}>
      {label && <label>{label}</label>}
      <textarea 
        ref={ref}
        id={id}
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        readOnly={readOnly}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        value={value}
        autoComplete={autoComplete}
        onBlur={onBlur}
        onFocus={onFocus}
        onAnimationStart={onAnimationStart}
        name={name}
        {...props}
        className={`${textAreaClassName} alteon-textarea`} {...props} style={{ height, width }} />
      {error && !disabled && !success && (
        <span className="alteon-error-text">{error}</span>
      )}
      {success && !disabled && !error && (
        <span className="alteon-success-text">{success}</span>
      )}
    </div>
  );
};

